import ViiluDialog from 'ui/components/ViiluDialog'
import { useState } from 'react'
import { useIntl } from 'react-intl'
import { CircularProgress } from 'react-md'
//import useText from './useText'
import { textHeaders } from './constants'
import TextFormInput from './TextFormInput'
import { CreateFormGrid } from 'ui/ManagerFinance/components'
import { FormProvider, useForm } from 'react-hook-form'
import { useZodValidationResolver } from 'util/hooks/useZodValidationResolver'
import { TextFormSchema } from './validation'
import type { TextFormInputs } from './validation'

type Props = {
	id?: string | null
	refresh: () => void
	onHide: () => void
}

const TextDialog = ({
	id,
	//refresh,
	onHide,
}: Props) => {
	const intl = useIntl()
	const [processing, setProcessing] = useState(false)

	//const { voucherType } = useText(id)

	const resolver = useZodValidationResolver<TextFormInputs>(TextFormSchema)

	const formMethods = useForm<TextFormInputs>({
		resolver,
		defaultValues: {},
		mode: 'onBlur',
		shouldUnregister: false,
	})

	const onProcess = async () => {
		setProcessing(true)
		setProcessing(false)
	}

	const renderFormFields = () => {
		return (
			<CreateFormGrid>
				{textHeaders.map((input, index) => (
					<TextFormInput
						key={`${input.key as string}-${index}`} //TODO: REMOVE AS STRING
						input={input}
					/>
				))}
			</CreateFormGrid>
		)
	}

	const renderChildren = () => {
		return (
			<div
				className="margin-left--lg margin-right--lg"
				style={{ paddingBottom: 64 }}
			>
				<FormProvider {...formMethods}>{renderFormFields()}</FormProvider>
			</div>
		)
	}

	const actions = [
		{
			id: 'dialog-cancel',
			children: intl.formatMessage({
				defaultMessage: 'Peruuta',
				description: 'Cancel button',
			}),
			onClick: onHide,
		},
		{
			id: 'dialog-ok',
			secondary: true,
			children: processing ? (
				<CircularProgress id="progress" style={{ marginTop: 0 }} />
			) : (
				intl.formatMessage({
					defaultMessage: 'Tallenna',
					description: 'Save button',
				})
			),
			onClick: onProcess,
		},
	]

	return (
		<ViiluDialog
			id="responsive-dialog"
			title={
				id
					? intl.formatMessage({
							defaultMessage: 'Muokkaa tekstiä',
							description: 'Title of edit text',
					  })
					: intl.formatMessage({
							defaultMessage: 'Lisää teksti',
							description: 'Title of add text',
					  })
			}
			visible={true}
			actions={actions}
			onHide={onHide}
			focusOnMount={true}
			containFocus={true}
			dialogClassName="responsive-dialog"
			contentClassName="responsive-dialog-content"
			autosizeContent={false}
			modal
			portal
			paddedContent
		>
			{renderChildren()}
		</ViiluDialog>
	)
}

export default TextDialog
